<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t('screencollectionreport') }}</div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <!-- START DATE -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getScreenCollectionReportFromDate"
                  v-on:click="onScreenCollectionReportDateHandler({ event: null, name: 'fromDate' })"
                >✖</button>
                <Datepicker :monday-first="true"
                  @selected="onScreenCollectionReportDateHandler({ event: $event, name: 'fromDate' })"
                  ref="programaticOpen"
                  :value="getScreenCollectionReportFromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="getScreenCollectionReportFromDate ? 'active': ''"
                >{{ $t('transaction') }} {{ $t('date') }}</label>
              </div>
            </div>
          </div>

          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="getScreenCollectionReportSelectedCinema && getScreenCollectionReportSelectedCinema.length > 0 ? 'shift-up' : ''"
              >{{ $t('select') }} {{ $tc('cinema', 1) }}</label>
              <b-dropdown
                :text="getScreenCollectionReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getCinemasList"
                  :key="dropdownIndex"
                  @click="onScreenCollectionReportDropdownHandler({ event: $event, name:'Cinema',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.cine_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button
              class="btn-blue-lg w-100"
              @click.prevent.stop="fetchScreenCollectionReportList"
            >{{ $t('fetch') }} {{ $t('report') }}</button>
          </div>
        </div>
      </div>

      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th>{{ $tc('screen', 1) }}</th>
              <th>{{ $t('film') }}</th>
              <th>{{ $t('show') }} No</th>
              <th>{{ $t('show') }} {{ $t('time') }}</th>
              <th>{{ $t('class') }}</th>
              <th>{{ $tc('ticket', 1) }} {{ $tc('category', 1) }}</th>
              <th>{{ $t('sold') }}</th>
              <th>{{ $t('rate') }}</th>
              <th>{{ $t('amount') }}</th>
            </tr>
          </thead>
          <tbody v-if="getScreenCollectionReportList.length === 0">
            <tr>
              <td colspan="9">
                <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div>
              </td>
            </tr>
          </tbody>
          <template v-if="getScreenCollectionReportList.length > 0">
            <tbody
              v-for="(GetScreenCollectionReportList, indexGetScreenCollectionReportList) in getScreenCollectionReportList"
              :key="indexGetScreenCollectionReportList"
            >
              <tr
                v-for="(Screens, ScreensIndex) in GetScreenCollectionReportList.screens"
                :key="ScreensIndex"
              >
                <!-- <td>{{ Screens.group.length > 0 ? Screens.group[0].screen_name : '' }}</td>
            <td>Avengers: End Game</td>
            <td>1</td>
            <td class="text-nowrap">11:30 AM</td>
            <td>Class</td>
            <td>General</td>
            <td>1</td>
            <td>30.00</td>
                <td>Amount</td>-->
                <td>{{ Screens.screen_name }}</td>
                <td>{{ Screens.movie_title }}</td>
                <td>{{ Screens.NoOfShowCount }}</td>
                <td class="text-nowrap">{{ Screens.t_show_time }}</td>
                <td>{{ Screens.sst_seat_type }}</td>
                <td>{{ Screens.srt_name }}</td>
                <td>{{ Screens.SoldNo }}</td>
                <td>{{ Screens.t_gross_amount }}</td>
                <td>{{ Screens.Amount | RoundOff }}</td>
              </tr>

              <tr class="bg-lightgrey">
                <td colspan="6" class="py-1">
                  <strong>{{ $t('total') }} {{ GetScreenCollectionReportList.screens.length > 0 ? `of ${GetScreenCollectionReportList.screens[0].screen_name}` : ''}}</strong>
                </td>
                <td>
                  <strong>{{ GetScreenCollectionReportList.screens.reduce(function(accumulator, { SoldNo }) { return accumulator + parseFloat(SoldNo); },0) }}</strong>
                </td>
                <td class="py-1"></td>
                <td class="py-1">
                  <strong>{{ GetScreenCollectionReportList.screens.reduce(function(accumulator, { Amount }) { return accumulator + parseFloat(Amount); },0).toFixed() }}</strong>
                </td>
              </tr>

              <!-- <tr>
            <td>Screen 2</td>
            <td>ANGEL HAS FALLEN</td>
            <td>1</td>
            <td>11:30 AM</td>
            <td>Class</td>
            <td>Ticket Category</td>
            <td>1</td>
            <td>30.00</td>
            <td>Amount</td>
          </tr>
          
          <tr class="bg-lightgrey">
            <td colspan="6" class="py-1">
              <strong>Total of SCREEN 1</strong>
            </td>
            <td>
              <strong>27</strong>
            </td>
            <td class="py-1"></td>
            <td class="py-1">
              <strong>915.00</strong>
            </td>
              </tr>-->
            </tbody>
            <tbody>
              <tr class="bg-lightgrey">
                <td colspan="6" class="py-1">
                  <strong>{{ $t('total') }}</strong>
                </td>
                <td>
                  <strong>{{ getScreenGrandTotal.totalSold }}</strong>
                </td>
                <td class="py-1"></td>
                <td class="py-1">
                  <strong>{{ getScreenGrandTotal.totalAmount }}</strong>
                </td>
              </tr>
            </tbody>
          </template>
        </table>
        <!-- {{ getScreenGrandTotal }} -->
        <div
          v-if="getScreenCollectionReportList.length > 0"
          class="d-flex justify-content-end mt-5 align-items-center"
        >
          <div>{{ $t('download') }} as:</div>
          <a
            v-if="getScreenCollectionPDFFileName"
            :href="BASE_URL+getScreenCollectionPDFFileName"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>

          <a
            v-if="getScreenCollectionExcelFileName"
            :href="BASE_URL+getScreenCollectionExcelFileName"
            target="_blank"
            download
            title="Download as Excel"
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      // Flags
      "getScreenCollectionReportsIsCinema",
      // End
      "getScreenCollectionReportList",
      "getScreenCollectionReportToDate",
      "getScreenCollectionReportFromDate",
      "getCinemasList",
      "getScreenCollectionReportSelectedCinema",

      // EXCEL
      "getScreenCollectionExcelFileName",
      // PDF
      "getScreenCollectionPDFFileName",
      // GET GRAND TOTAL
      "getScreenGrandTotal"
    ])
  },
  beforeMount() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.onScreenCollectionReportFlagHandler({
      event: null,
      name: "isCinema",
      value: cinemaId
    });
    this.onScreenCollectionReportFlagHandler({
      event: null,
      name: "isCountry",
      value: this.secureStore.get("BRGLOPCO") || null
    });
    this.fetchCinemasList({ cinemaId });
  },
  mounted() {},
  methods: {
    ...mapActions([
      "fetchCinemasList",

      "fetchScreenCollectionReportList",
      "onScreenCollectionReportDateHandler",
      "onScreenCollectionReportDropdownHandler",
      "onScreenCollectionReportFlagHandler",
      // RESET STORE
      "onResetScreenCollectionReportStoreState"
    ])
  },
  beforeDestroy: async function() {
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getScreenCollectionExcelFileName
    });
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getScreenCollectionPDFFileName
    });
    await this.onResetScreenCollectionReportStoreState();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/screenWiseCollectionReport.vue